import { EventStatus } from '../types';

export const invalidStatuses = Object.freeze([
  EventStatus.EVENT_STATUS_CANCELLED,
  EventStatus.EVENT_STATUS_WITHDRAWN,
  EventStatus.EVENT_STATUS_ARCHIVED,
  EventStatus.EVENT_STATUS_DELETED,
]);
